import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import axios from 'util/axios';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Pagination, { SetPager } from "util/component/Pagination/v2";
const VIEW_PAGE = 6;

const MyReview = (props, ref) => {
    const [List, SetList] = useState([]);
    const [Loading, SetLoading] = useState(true);
    const userSelector = useSelector((store) => store.user);
    const { t } = useTranslation(["page"]);

    const TBL_DATA_ORIGIN = useRef([]);
    const [PAGER, SetPAGER] = useState(null);

    const [ Sorting, SetSorting ] = useState({column: "reviewing", order: "asc"})

    const getList = async () => {
        SetLoading(true);
        try {
            const response = await axios
                .post(process.env.REACT_APP_API + "/pcsReview/retrieveReviewSheetList", {
                    userId: userSelector.userId,
                    page:"myPage"
                })
                .then((Response) => Response.data.data.result);

            TBL_DATA_ORIGIN.current = response?.filter((f) => f.reviewEnd === "N") || [];
            const pager = new SetPager(TBL_DATA_ORIGIN.current.length, VIEW_PAGE);
            SetPAGER({ data: pager });
        } catch (e) {
            SetList([]);
        } finally {
            SetLoading(false);
        }
    };

    useEffect(() => {
        if (!PAGER) return;
        const range = PAGER.data.getItemRange();
        let setData = [];
        TBL_DATA_ORIGIN.current?.sort((a,b) => {
            if(Sorting.order === "asc") {
                if(a[Sorting.column] > b[Sorting.column]) return 1
                if(a[Sorting.column] === b[Sorting.column]) return 0
                if(a[Sorting.column] < b[Sorting.column]) return -1
                return 0
            } else {
                if(a[Sorting.column] > b[Sorting.column]) return -1
                if(a[Sorting.column] === b[Sorting.column]) return 0
                if(a[Sorting.column] < b[Sorting.column]) return 1
                return 0
            }
        })

        for (let i = range.start; i < range.end; i++) {
            setData.push(TBL_DATA_ORIGIN.current[i]);
        }
        SetList(setData);
    }, [PAGER, Sorting]);

    const HandleSort = (column) => {
        SetSorting(OLD => ({column: column, order: (OLD.column === column && OLD.order === "desc") ? "asc" : "desc"}))
    }

    useEffect(() => {
        getList();

        return () => {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    return (
        <div className={"position-relative"}>
            <div className={"refresh-btn"} onClick={getList}>
                <FontAwesomeIcon icon={faArrowRotateRight} />
            </div>
            <table className={"bpl-table-default small compact has-pagination fixed text-center"} style={{ fontSize: "0.8rem" }}>
                <colgroup>
                    <col width="70" />
                    <col width="70" />
                    <col width="80" />
                    <col width="60" />
                    <col />
                    <col width="135" />
                </colgroup>
                <thead>
                    <tr>
                        <th className={`clickable sort-header ${Sorting.column === "project" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("project")}>Project</th>
                        <th className={`clickable sort-header ${Sorting.column === "process" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("process")}>Process</th>
                        <th>Revision</th>
                        <th className={`clickable sort-header ${Sorting.column === "round" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("round")}>Round</th>
                        <th className={`clickable sort-header ${Sorting.column === "reviewing" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("reviewing")}>Review Status</th>
                        <th className={`clickable sort-header ${Sorting.column === "dueDate" ? Sorting.order : ""}`}
                            onClick={() => HandleSort("dueDate")}>Due Date</th>
                    </tr>
                </thead>
                <tbody>
                    {!Loading &&
                        (List && List.length > 0) ?
                        List?.map((rowData, index) => {
                            const { geneCode, tempYn, revision, round, project, process, reviewEnd, dueDate, ownerId } = rowData;
                            let reviewing;
                            switch (rowData.reviewing) {
                                case "Y":
                                    reviewing = <span className={"rev-end"}>Review End</span>;
                                    break;
                                case "C":
                                    reviewing = <span className={"rev-complete"}>Completed</span>;
                                    break;
                                case "I":
                                    reviewing = <span className={"rev-ing"}>In-progress</span>;
                                    break;
                                case "N":
                                    reviewing = <span className={"rev-not"}>Not started</span>;
                                    break;
                                default:
                                    reviewing = <span className={"rev"}>N/A</span>;
                            }
                            return (
                                <tr
                                    key={`myReviewList${index}`}
                                    onClick={() => {
                                        let isExternal = userSelector.isExternal;
                                        window.location.href = `/review${isExternal ? "-ex": ""}?geneCode=${geneCode}&revision=${revision}&tempYn=${tempYn}&ownerId=${ownerId}`;
                                    }}
                                    className={"clickable"}
                                >
                                    <td>{project}</td>
                                    <td>{process}</td>
                                    <td>
                                        <span className={tempYn === "Y" ? "bpl-temp-v2 smaller" : ""}>{revision}</span>
                                    </td>
                                    <td>{round}</td>
                                    <td>{reviewing}</td>
                                    <td>{dueDate}</td>
                                </tr>
                            );
                        }) : (
                            <tr>
                                <td colSpan={6}>No Results</td>
                            </tr>
                        )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="6">
                            <Pagination data={PAGER?.data} v2 set={(data) => SetPAGER({ data: data, refresh: new Date() })} />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};
export default MyReview;
